import React from "react";

/**
 * A custom toggle button component.
 * @param {Object} props - The props object containing the following properties:
 *   - {Function} onCheckChange - The callback function to be called when the toggle button is checked or unchecked.
 *   - {Function} onClick - The callback function to be called when the toggle button is clicked.
 *   - {boolean} checked - The current checked state of the toggle button.
 *   - {string} id - The unique identifier for the toggle button.
 * @returns {JSX.Element} - The rendered toggle button component.
 */
const CustomToggleButton = (props) => {

  /**
   * Destructures the necessary properties from the props object.
   * @param {object} props - The props object containing the necessary properties.
   * @returns None
   */
  const { onCheckChange, onClick, checked, id, disabled } = props;

  /**
   * Handles the event when the toggle button is checked or unchecked.
   * Calls the onCheckChange function with the checked value of the toggle button.
   * @param {Event} e - The event object.
   * @returns None
   */
  const onToggleButtonChecked = (e) => {
    return onCheckChange && onCheckChange(e.target.checked);
  };

  /**
   * Renders a toggle switch component.
   * @param {string} id - The unique identifier for the toggle switch.
   * @param {boolean} checked - The current state of the toggle switch (true for checked, false for unchecked).
   * @param {function} onClick - The function to be called when the toggle switch is clicked.
   * @param {function} onChange - The function to be called when the toggle switch state changes.
   * @returns {JSX.Element} - The rendered toggle switch component.
   */
  return (
    <>
      <div className="form-check form-switch form-switch-md">
        <input
          type="checkbox"
          className="form-check-input"
          id={id}
          checked={checked}
          onClick={onClick}
          onChange={onToggleButtonChecked}
          disabled={disabled ? true : false}
        />
      </div>
    </>
  );
};
export default CustomToggleButton;
